import {
  membersFFAppDefId,
  wixBlogAppDefinitionId,
} from '../constants/app-definition-id';
import { blogSectionId, ffSectionId } from '../constants/section-id';
import { FOLLOWERS_FOLLOWING_WIDGET_ID } from '../constants/widgets-ids';
import type { WixCodeApi } from '../types/controller';
import type { GetPublicAPI } from './public-api-store';
import { Applications } from './public-api-store';

export type ResolvedInstalledApps = {
  wixBlog: boolean;
  membersFF: boolean;
};

const isWixBlogInstalled = (wixCodeApi: WixCodeApi): boolean =>
  Boolean(
    wixCodeApi.site.isAppSectionInstalled?.({
      appDefinitionId: wixBlogAppDefinitionId,
      sectionId: blogSectionId,
    }),
  );

const isMembersFFInstalled = async (
  getPublicAPI: GetPublicAPI,
): Promise<boolean> => {
  const membersAreaApi = await getPublicAPI(Applications.MembersArea);
  if (!membersAreaApi) {
    return false;
  }

  return membersAreaApi.isAppSectionInstalled({
    appDefinitionId: membersFFAppDefId,
    sectionId: ffSectionId,
    widgetId: FOLLOWERS_FOLLOWING_WIDGET_ID,
  });
};

export const resolveInstalledApps = async (
  wixCodeApi: WixCodeApi,
  getPublicAPI: GetPublicAPI,
): Promise<ResolvedInstalledApps> => {
  const [wixBlog, membersFF] = await Promise.all([
    Promise.resolve(isWixBlogInstalled(wixCodeApi)),
    isMembersFFInstalled(getPublicAPI),
  ]);

  return { wixBlog, membersFF };
};
